import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const state = () => ({
	courseData: {},
	versionId: null,
	isLatestVersion: true,
});
const getters = {
	getCourseData: (state) => state.courseData,
	getVersionId: (state) => state.versionId,
	getIsLatestVersion: (state) => state.isLatestVersion,
};
const mutations = {
	GET_COURSE_DATA(state, payload) {
		state.courseData = payload;
	},
	GET_VERSION_ID(state, payload) {
		state.versionId = payload;
	},
	SET_IS_LATEST_VERSION(state, payload) {
		state.isLatestVersion = payload;
	},
};
export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
